export default __webpack_public_path__ + "grab-refresh.89f8e2bcbe3a98a4d6f6431b780e0ccf.png";